import { gql } from 'graphql-request';
import {
	SAVED_MARKET_STATE_FILTER_FILTER_FRAGMENT
} from '@app/model/market_state/_saved_filters/service/SavedMarketStateFilterGraphQLFragments';
import { REPORT_EXECUTION_FRAGMENT } from '@app/model/market_state/_export/service/MarketStateExportGraphQLFragments';

export const PARITY_EXPORT_REPORT_FRAGMENT = gql`
	${SAVED_MARKET_STATE_FILTER_FILTER_FRAGMENT}
	fragment ParityExportReportFields on ParityExportReport {
		id
		companyHotelId
		name
		creationDate
		reportType
		scope
		period
		fromDate
		toDate
		filter {
			...SavedMarketStateFilterFilterFragment
		}
	}
`;

export const PARITY_EXPORT_REPORT_EXECUTION_FRAGMENT = gql`
	${PARITY_EXPORT_REPORT_FRAGMENT}
	${REPORT_EXECUTION_FRAGMENT}
	fragment ParityExportReportExecutionFields on ParityExportReportExecution {
		execution {
			...ReportExecutionFields
		}
		report {
			...ParityExportReportFields
		}
	}
`;
